import * as React from "react";
import { useEffect, useState } from "react";
import Modal from "../../../component/Global/Modal";
import ReusableDiv from "src/support/ReusableDiv";
import Helper from "src/support/Helper";
import { useUserStore } from "src/hooks/admin/user";
import Constants from "src/support/Constants";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import useReduxState from "src/hooks/useReduxState";
import AlertContentWithFlag from "src/pages/Checkout/AlertContentWithFlag";

const AddUser = (props) => {
  const [status, SetStatus] = useState(false);
  const [{ }, { }, { add_user, check_user_email }] = useUserStore();
  const emailPattern = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
  const [__check] = useAxiosIndicatorCheck();
  const [detailValidation, setDetailValidation] = useState({});
  const [, setRefreshGrid] = useReduxState(false, "setRefreshGrid");
  const [error,setError] = useState("");
  const [emailStatus, setEmailStatus] = useState(false)
  const [, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
  const [, setErrAlertType] = useReduxState("", "setErrAlertType");

  const modal = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    mobileNumber: "",
    telephoneNumber: "",
    userType: "External"
  };
  const [userDetail, setUserDetail] = useState(modal);
  useEffect(() => {
    SetStatus(true);
  }, []);

  const onHide = () => {
    SetStatus(false);
  };

  const onValueChange = (field, value) => {
    if (detailValidation && Object.keys(detailValidation).length > 0) {
      delete detailValidation[field];
    }
    setUserDetail({ ...userDetail, [field]: value });

    if (userDetail.userType === 'Internal' && field === 'emailAddress' && emailStatus) {
      setUserDetail({ ...modal, emailAddress: value, userType: "Internal" });
    }

    if (field === "userType") {
      setUserDetail({ ...modal, userType: value });
      setDetailValidation({});
    }

    setError("")
  };

  const onExistingEmailCheck = async () => {
    setError("");
    let isValid = validateEmail()

    if (isValid) {
      __set("CHECK_USER_EMAIL");
      const res = await check_user_email(userDetail.emailAddress)
      if (res && res?.isSuccessFull) {
        setEmailStatus(true)
        setUserDetail({ ...res?.data, userType: res?.data?.userType == 0 ? "Internal" : 'External' })
      } else if (res && res.Message) {
        let validationModal = {}
        validationModal.emailAddress = res.Message;
        setDetailValidation(validationModal);
      } else {
        setError(res?.message || res?.errorMessage || "Oh snap! The user could not be added. Please try again.");
      }
      __remove("CHECK_USER_EMAIL");
    }
  };

  const onSaveUser = async () => {
    setError("")
    __set("ADD_USER_API_CALL");

    let isValid = userDetail?.userType === "External" ? onValidateData() : validateEmail()
    if (isValid) {
      const res = await add_user(userDetail);
      if (res && res.isSuccessFull) {
        const message = userDetail?.userType === "External" ? ("You have successfully added " +
        res.username +
        " to the system. An email has been sent to them for confirmation") : ("You have successfully added " +
        res.username +  " to the system.")
        setTimeout(() => {
          setUserListErrAlert(message, 'success', 'removeUser');
          setErrAlertType('success');
          setRefreshGrid(true);
        }, 500);
        onHide();
      } else if (res && res.Message) {
            let validationModal = {}
            if (['422', '402', '404'].includes(res?.ErrorCode)) {
                validationModal.emailAddress = res.Message;
                setDetailValidation(validationModal);
            } else {
              setError(res?.message || res?.errorMessage || "Oh snap! The user could not be added. Please try again.");
            }
      } else {
        setError(res?.message || res?.errorMessage || "Oh snap! The user could not be added. Please try again.");
      }
    }
    __remove("ADD_USER_API_CALL");
  };

  const onValidateData = () => {
    let validationModal = {};
    Helper.valueIsNotNull(userDetail.firstName)
      ? ""
      : (validationModal.firstName = "Enter First Name");
    Helper.valueIsNotNull(userDetail.lastName)
      ? ""
      : (validationModal.lastName = "Enter Last Name");
    Helper.valueIsNotNull(userDetail.emailAddress)
      ? Helper.validateRegex(userDetail.emailAddress, emailPattern) === false
        ? (validationModal.emailAddress =
          "Invalid Email, Please enter valid Email Address")
        : ""
      : (validationModal.emailAddress = "Enter Email Address");
    validationModal.emailAddress
      ? ""
      : Helper.validateDomain(userDetail.emailAddress)
        ? ""
        : (validationModal.emailAddress =
          "For Avnet users, please select the internal user option.");
    setDetailValidation(validationModal);
    return Object.keys(validationModal).length > 0 ? false : true;
  };

  const validateEmail = () => {
    let validationModal = {};
    Helper.valueIsNotNull(userDetail.emailAddress)
      ? Helper.validateRegex(userDetail.emailAddress, emailPattern) === false
        ? (validationModal.emailAddress =
          "Invalid Email, Please enter valid Email Address")
        : ""
      : (validationModal.emailAddress = "Enter Email Address");
    Helper.validateDomain(userDetail.emailAddress) ? validationModal.emailAddress =
      "For external users, please select external option." : ""
    setDetailValidation(validationModal);
    return Object.keys(validationModal).length > 0 ? false : true;
  }

  const enableField = Helper.valueIsNotNull(userDetail.firstName) && Helper.valueIsNotNull(userDetail.lastName) &&
    Helper.valueIsNotNull(userDetail.emailAddress) && Helper.validateRegex(userDetail.emailAddress, emailPattern)
    && Object.keys(detailValidation).length === 0

  const UserFields = () => {
    const valid = userDetail?.userType === "External"
    return (
      <>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="firstName" className="d-block">
                First Name*
              </label>
              <input
                type="text"
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.firstName
                    ? " error"
                    : ""
                  }`}
                id="firstName"
                placeholder="First Name"
                name="firstName"
                value={userDetail.firstName}
                onChange={({ target: { value } }) =>
                  onValueChange("firstName", value)
                }
                disabled={!valid}
              />
              {valid && detailValidation.firstName && (
                <p className="error"> {detailValidation.firstName}</p>
              )}
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label htmlFor="mobileNumber" className="d-block">
                Mobile Number
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="mobileNumber"
                placeholder="Mobile Number"
                name="mobileNumber"
                value={userDetail.mobileNumber}
                onChange={({ target: { value } }) =>
                  onValueChange("mobileNumber", value)
                }
                disabled={!valid}
              />
            </div>
          </div>
        </div>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="lastName" className="d-block">
                Last Name*
              </label>
              <input
                type="text"
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.lastName
                    ? " error"
                    : ""
                  }`}
                id="lastName"
                placeholder="Last Name"
                name="lastName"
                value={userDetail.lastName}
                onChange={({ target: { value } }) =>
                  onValueChange("lastName", value)
                }
                disabled={!valid}
              />
              {valid && detailValidation.lastName && (
                <p className="error"> {detailValidation.lastName}</p>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="telephoneNumber" className="d-block">
                Telephone Number
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="telephoneNumber"
                placeholder="Telephone Number"
                name="telephoneNumber"
                value={userDetail.telephoneNumber}
                onChange={({ target: { value } }) =>
                  onValueChange("telephoneNumber", value)
                }
                disabled={!valid}
              />
            </div>
          </div>
        </div>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="email" className="d-block">
                Email Address*
              </label>
              <input
                type="text"
                className={`form-control form-control-sm ${detailValidation && detailValidation.emailAddress
                    ? " error"
                    : ""
                  }`}
                id="email"
                placeholder="Email Address"
                name="emailAddress"
                value={userDetail.emailAddress}
                onChange={({ target: { value } }) =>
                  onValueChange("emailAddress", value)
                }
                onBlur={() => {
                  if (userDetail.emailAddress) {
                    if (!emailPattern.test(userDetail.emailAddress)) {
                      setDetailValidation({ ...detailValidation, emailAddress: 'Valid characters include A-z, 0-9, and (-._@$%+)' });
                      return;
                    }
                    if (!valid) {
                      onExistingEmailCheck()
                    }
                  }
                }}
              />
              {detailValidation.emailAddress && (
                <p className="error">
                  {" "}
                  {detailValidation.emailAddress}
                </p>
              )}
            </div>

          </div>
          <div className="col-6">
            <div className="form-group m-t-25">
              {__check(["CHECK_USER_EMAIL"]).status &&
                <i className="fa fa-spinner fa-spin" />
              }
            </div>

          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Modal
        show={status}
        onHide={() => {
          onHide();
        }}
      >
        <div className="avnet-modal modal-730">
          <div className="avnet-modal-inner">
            <button
              type="button"
              className="close py-3"
              data-dismiss="modal"
              onClick={() => {
                onHide();
              }}
            >
              ×
            </button>
            {ReusableDiv.PopupTitle("Add User")}
            <div className="modal-body">
            {error && <AlertContentWithFlag message={error} type="danger" isDisplay={false} isDisplayIcon={true} addUsercontainer={true} /> }
              <form>

                <p className="fw-bold">
                  Please select the type of user you would like to add:
                </p>
                <div className="bs5 row">
                  <div className="form-check-inline d-inline-flex align-items-center">
                    <div className="form-check form-check-inline d-inline-flex align-items-center pr-5 pb-3">
                      <input
                        type="radio"
                        className="form-check-input font-14"
                        id="externalUser"
                        // value={userDetail?.externalUser}
                        onChange={({ target: { checked } }) =>
                          onValueChange("userType", Constants.userType.EXTERNAL)
                        }
                        name="users"
                        defaultChecked
                      />
                      <label
                        className="form-check-label mt-0 ms-2"
                        htmlFor="externalUser"
                      >
                        External User
                      </label>
                    </div>
                    <div className="form-check form-check-inline d-inline-flex align-items-center pr-5 pb-3">
                      <input
                        type="radio"
                        className="form-check-input font-14"
                        id="internalUser"
                        // value={userDetail?.internalUser}
                        onChange={({ target: { checked } }) =>
                          onValueChange("userType", "Internal")
                        }
                        // value="Internal User"
                        name="users"
                      />
                      <label
                        className="form-check-label mt-0 ms-2"
                        htmlFor="internalUser"
                      >
                        Internal User
                      </label>
                    </div>
                  </div>
                </div>
                {UserFields()}
              </form>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button
                type="button"
                className="bs5 btn btn-secondary minw140"
                onClick={() => {
                  onHide();
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="bs5 btn btn-primary minw140"
                disabled={__check(["ADD_USER_API_CALL"]).status || !enableField}
                onClick={() => {
                  __check(["ADD_USER_API_CALL"]).status
                    ? e.preventDefault()
                    : onSaveUser();
                }}
              >
                {(__check("ADD_USER_API_CALL").status) ? (
                  <i className="fa fa-spinner fa-spin" />
                ) : (
                  "Add User"
                )}{" "}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddUser;
